var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:['out-of-stock', { 'out-of-stock--singlepage': _vm.singlepage }]},[_c('span',{staticClass:"out-of-stock__icon"},[_vm._v("⚠")]),_vm._v(" "+_vm._s(_vm.$t('product_form.sold_out'))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }